import React, { useState, useCallback, useEffect } from "react";
import { useLogin } from "../hooks/useLogin";
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from 'react-router-dom';
import { SESSION_EXPIRED_KEY } from '../context/AuthContext';

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const { login, googleLogin, error, isLoading } = useLogin();
    // Shown once after being sent here because the previous login expired.
    const [sessionExpired] = useState(() => sessionStorage.getItem(SESSION_EXPIRED_KEY) === '1');
    useEffect(() => { sessionStorage.removeItem(SESSION_EXPIRED_KEY); }, []);

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        await login(email, password);
    };

    const googleSuccess = async (res) => {
        console.log(res);
        const credential= res?.credential;
        console.log("credential: " + credential);

        try {
            console.log("credential: " + credential);
            await googleLogin(credential);
        } catch (error) {
            console.log(error);
        }
    }

    const googleFailure = (error) => {
        console.log(error);
        console.log("Google Sign In was unsuccessful. Try again later");
    }

    return (
        <form className="login" onSubmit={handleSubmit}>
            <h3> Log in</h3>
            {sessionExpired && <div className="error">Your login has expired. Please log in again.</div>}

            <label>Email:</label>
            <input
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
            />
            <label>Password:</label>
            <input
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
            />

            <button 
                type="button" 
                style={{
                    backgroundColor: "transparent", 
                    border: "none", 
                    color: "grey", 
                    textDecoration: "underline", 
                    cursor: "pointer"
                }}
                onClick={() => navigate('/reset_password')}
            >
                Forgot Password?
            </button>

            <div className="login_mechanisms" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <button disabled={isLoading} className="submit-button">Log in</button>
                {error && <div className="error">{error}</div>}
            </div>
        </form>
    );
};

export default Login;